module.exports = __webpack_public_path__ + "static/media/2015_composite.3ee27a08.jpg";